import React from 'react';
import { useRoleAwareLayout } from '../../../hooks/responsive/useResponsive';

const DashboardSection = ({ 
  title, 
  children, 
  variant = 'default',
  showForRoles = ['parent', 'kid'],
  showOnBreakpoints = ['mobile', 'tablet', 'desktop'],
  className = '',
  ...props 
}) => {
  const { userRole, breakpoint } = useRoleAwareLayout();
  
  // Conditional rendering based on role and breakpoint
  if (!showForRoles.includes(userRole)) return null;
  if (!showOnBreakpoints.includes(breakpoint)) return null;
  
  const sectionClasses = [
    'dashboard-section',
    `dashboard-section--${variant}`,
    `dashboard-section--${breakpoint}`,
    `dashboard-section--${userRole}`,
    'bg-white rounded-lg shadow-sm border border-stone-200 p-6',
    className
  ].filter(Boolean).join(' ');
  
  return (
    <section className={sectionClasses} {...props}>
      {title && (
        <h2 className="dashboard-section__title text-xl font-semibold text-slate-900 mb-4">
          {title}
        </h2>
      )}
      <div className="dashboard-section__content">
        {children}
      </div>
    </section>
  );
};

export default DashboardSection;